import { apiRequest } from './client';

export function fetchInvoices(token) {
  return apiRequest('/admin/invoices', token);
}

export function fetchInvoice(token, id) {
  return apiRequest(`/admin/invoices?id=${id}`, token);
}

export function generateInvoice(token, orderId) {
  return apiRequest('/admin/invoices', token, {
    method: 'POST',
    body: JSON.stringify({ orderId }),
  });
}
